import useViewModel from "./viewModel";
import View from "./view";

const Activate = () => {
  const viewModel = useViewModel();

  return <View {...viewModel} />;
};

export default Activate;
